import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";

export function useTeam() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [deliverers, setDeliverers] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const [dRes, mRes] = await Promise.all([
        authAxiosRef.current.get("/deliverers"),
        authAxiosRef.current.get("/deliverers/team/members"),
      ]);
      setDeliverers(dRes.data);
      setMembers(mRes.data);
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  return { deliverers, members, loading, fetchData };
}
